import axios from "axios";
// import router from "./router";
import store from "./store";
import constant from "./constant";


axios.defaults.baseURL = constant.API_URL;

axios.interceptors.request.use(config => {

    store.dispatch("configapp/setLoader",{
        isLoading: true,
        fullPage: true,
        canCancel: false
    });

    const token = store.getters["auth/access_tokenp"];
    if (token) {
        config.headers.common['Authorization'] = token;
    }

    return config
}, error => {
    store.dispatch("configapp/setLoader",{
        isLoading: false,
        fullPage: false,
        canCancel: false
    });
    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    store.dispatch("configapp/setLoader",{
        isLoading: false,
        fullPage: false,
        canCancel: false
    });
    return response
}, (error) => {

    const originalRequest = error.config;

    store.dispatch("configapp/setLoader",{
        isLoading: false,
        fullPage: false,
        canCancel: false
    });

    if (error.response.status !== 401) {

        if(error.response.status === 403){
            // router.push({ name: "page403"});
            return Promise.reject(error);
        }

        return Promise.reject(error);
    }


    //On arrive ici si seulement si le statut == 401
    if(error.config.url === '/token/refresh' || error.config.url === '/logout-client'){
        //si le refresh token ou logout return un statut == 401, on deconnecte user

        store.dispatch("auth/forceLogout").then(()=>{
            //router.push({ name: "login" });
        });

        return Promise.reject(error);

    }

    if (!originalRequest._retry) {

        originalRequest._retry = true;

        return  store.dispatch("auth/refreshTokens").then(() => {
            originalRequest.headers['Authorization'] =  store.getters["auth/access_tokenp"];
            return axios(originalRequest);
        }).catch((err)=>{
            return Promise.reject(error);
        });
    }

    //retour du nouveau token
    return Promise.reject(error);

    //return Promise.reject(error);
});

window.axios = axios;

window.Timer = 10500;
